module.exports = __webpack_public_path__ + "img/1440.fb127e94.jpg";